import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlay12Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPlay12Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M1.415 9.523V2.527a1 1 0 0 1 1.449-.893l7.004 3.514a1 1 0 0 1-.004 1.79l-7.004 3.48a1 1 0 0 1-1.445-.895"
            />
        </svg>
    );
}
export default memo(IconPlay12Filled);
